import { Chip, Divider, List, ListItem, ListItemText, Stack, Typography } from '@mui/material';

import { DomainStoryRevisionModel } from '../../api/api';

export default function DomainStoryOutline({ revision }: { revision: DomainStoryRevisionModel }) {
	return (
		<Stack spacing={2.5} sx={{ p: { xs: 2, md: 3 }, maxWidth: 980 }}>
			<section>
				<Typography variant="h6">{revision.title}</Typography>
				<Typography variant="body2" color="text.secondary" sx={{ mt: 0.75, whiteSpace: 'pre-wrap' }}>{revision.description}</Typography>
			</section>
			<Divider />
			<section>
				<Typography variant="subtitle2" gutterBottom>Actors</Typography>
				<Stack direction="row" gap={1} flexWrap="wrap">
					{revision.actors.map((actor) => <Chip key={actor.actorId ?? actor.displayName} label={`${actor.displayName} · ${actor.actorType}`} size="small" variant="outlined" />)}
					{revision.actors.length === 0 && <Typography variant="body2" color="text.secondary">No actors identified.</Typography>}
				</Stack>
			</section>
			<section>
				<Typography variant="subtitle2" gutterBottom>Work Objects</Typography>
				<Stack direction="row" gap={1} flexWrap="wrap">
					{revision.workObjects.map((item) => <Chip key={item.id ?? item.name} label={item.name} size="small" color="primary" variant="outlined" />)}
					{revision.workObjects.length === 0 && <Typography variant="body2" color="text.secondary">No work objects identified.</Typography>}
				</Stack>
			</section>
			<section>
				<Typography variant="subtitle2">Story Steps</Typography>
				<List disablePadding>
					{[...revision.steps].sort((left, right) => left.sequence - right.sequence).map((step) => (
						<ListItem key={step.id ?? step.sequence} alignItems="flex-start" disableGutters>
							<ListItemText
								primary={`${step.sequence}. ${step.sentence}`}
								secondary={step.flowSegments.length ? step.flowSegments.map((segment) => segment.activity).join(' · ') : undefined}
							/>
							{step.optional && <Chip label="Optional" size="small" variant="outlined" />}
						</ListItem>
					))}
					{revision.steps.length === 0 && <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>No story steps captured.</Typography>}
				</List>
			</section>
			{revision.questions.length > 0 && (
				<section>
					<Typography variant="subtitle2">Open Questions</Typography>
					<List dense disablePadding>{revision.questions.map((question) => <ListItem key={question.id ?? question.question} disableGutters><ListItemText primary={question.question} secondary={question.status} /></ListItem>)}</List>
				</section>
			)}
			{revision.potentialStories.length > 0 && (
				<section>
					<Typography variant="subtitle2">Potential Stories</Typography>
					<List dense disablePadding>{revision.potentialStories.map((story) => <ListItem key={story.id ?? story.title} disableGutters><ListItemText primary={story.title} secondary={story.reason} /></ListItem>)}</List>
				</section>
			)}
		</Stack>
	);
}
